import React from 'react';
import Header from '../components/Header/Header';
import ImageGallery from '../components/ImageGallery/ImageGallery';
import PropertyHeader from '../components/PropertyHeader/PropertyHeader';
import PropertyOverview from '../components/PropertyOverview/PropertyOverview';
import PropertyDescription from '../components/PropertyDescription/PropertyDescription';
import Amenities from '../components/Amenities/Amenities';
import PropertyDetailsTable from '../components/PropertyDetailsTable/PropertyDetailsTable';
import AgentCard from '../components/AgentCard/AgentCard';
import LocationSection from '../components/LocationSection/LocationSection';
import SimilarProperties from '../components/SimilarProperties/SimilarProperties';
import Footer from '../components/Footer/Footer';
import './PropertyDetail.css';

function PropertyDetail() {
  const property = {
    id: 'PKM-001',
    title: 'Luxury 5 Bedroom Villa with Swimming Pool',
    location: 'DHA Phase 6, Karachi',
    price: 'PKR 1.5 Crore',
    pricePerSqft: 'PKR 30,000/sq ft',
    beds: 5,
    baths: 6,
    area: '500 sq yd',
    type: 'House',
    postedDate: '2 days ago',
    purpose: 'Sale',
    featured: true,
    verified: true,
    images: [
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800',
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800'
    ],
    description: `This stunning luxury villa offers an exceptional living experience in one of Karachi's most prestigious neighborhoods. Spread across a generous 500 square yards, this meticulously designed property features 5 spacious bedrooms and 6 modern bathrooms.

The villa showcases contemporary architecture with high-quality finishes throughout. The open-plan living and dining areas create a perfect space for entertaining, while floor-to-ceiling windows flood the interiors with natural light.

The property includes a private swimming pool, landscaped garden, and dedicated parking for multiple vehicles. Each bedroom comes with en-suite facilities and built-in wardrobes. The master suite features a walk-in closet and a luxurious bathroom with premium fixtures.

Located in the heart of DHA Phase 6, residents enjoy easy access to top schools, hospitals, shopping centers, and recreational facilities. This is an ideal home for families seeking luxury, comfort, and convenience.`,
    amenities: [
      'Parking',
      'Garden',
      'Swimming Pool',
      'Gym',
      'Security',
      'Elevator',
      'Balcony',
      'Central Heating',
      'Central AC',
      'Furnished',
      'Nearby Mosque',
      'Nearby School'
    ],
    details: {
      'Property Type': 'House',
      'Property Size': '500 sq yd',
      'Bedrooms': '5',
      'Bathrooms': '6',
      'Year Built': '2020',
      'Flooring': 'Marble',
      'Parking Spaces': '3',
      'Heating': 'Central',
      'Cooling': 'Central AC',
      'Total Floors': '2',
      'Kitchen': 'Modular',
      'Electricity': 'KESC'
    }
  };

  const agent = {
    name: 'Ahmed Khan',
    agency: 'Premium Properties Ltd.',
    photo: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200',
    verified: true,
    rating: 4.8,
    reviews: 156,
    properties: 87,
    experience: 12,
    phone: '+92 300 1234567'
  };

  const nearbyPlaces = [
    { name: 'DHA Golf Club', distance: '0.5 km' },
    { name: 'Karachi Grammar School', distance: '1.2 km' },
    { name: 'Agha Khan Hospital', distance: '2.0 km' },
    { name: 'Dolmen Mall', distance: '1.5 km' },
    { name: 'Masjid-e-Tooba', distance: '3.2 km' },
    { name: 'Seaview Beach', distance: '5.0 km' }
  ];

  const similarProperties = [
    {
      id: 2,
      images: [
        'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
        'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=800&q=80',
        'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80'
      ],
      price: 'PKR 1.2 Crore',
      pricePerSqft: 'PKR 30,000/sq yd',
      title: 'Modern 4 Bedroom House',
      location: 'DHA Phase 5, Karachi',
      beds: 4,
      baths: 5,
      area: '400 sq yd',
      type: 'House',
      postedDate: '1 week ago',
      featured: false,
      verified: true
    },
    {
      id: 3,
      images: [
        'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
        'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800&q=80',
        'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80'
      ],
      price: 'PKR 1.8 Crore',
      pricePerSqft: 'PKR 30,000/sq yd',
      title: 'Spacious Villa with Garden',
      location: 'DHA Phase 7, Karachi',
      beds: 6,
      baths: 7,
      area: '600 sq yd',
      type: 'House',
      postedDate: '3 days ago',
      featured: true,
      verified: true
    },
    {
      id: 4,
      images: [
        'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
        'https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?w=800&q=80',
        'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800&q=80'
      ],
      price: 'PKR 1.3 Crore',
      pricePerSqft: 'PKR 28,888/sq yd',
      title: 'Elegant Family Home',
      location: 'DHA Phase 6, Karachi',
      beds: 5,
      baths: 5,
      area: '450 sq yd',
      type: 'House',
      postedDate: '5 days ago',
      featured: false,
      verified: false
    }
  ];

  return (
    <div className="property-detail-page">
      <Header />

      <div className="property-detail-container">
        <div className="property-detail-content">
          <div className="property-main-content">
            <ImageGallery images={property.images} />
            <PropertyHeader property={property} />
            <PropertyOverview property={property} />
            <PropertyDescription description={property.description} />
            <Amenities amenities={property.amenities} />
            <PropertyDetailsTable details={property.details} />
            <LocationSection
              location={property.location}
              nearbyPlaces={nearbyPlaces}
            />
            <SimilarProperties properties={similarProperties} />
          </div>

          <div className="property-sidebar">
            <AgentCard agent={agent} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PropertyDetail;
